module.exports = __webpack_public_path__ + "static/media/8.2d48ad9e.png";